import React from 'react'
import Header from './Header'


class Page extends React.Component {
  render() {
    return <div>
      
      <Header title={this.props.title} backbutton={this.props.backbutton || false} menucallback={this.props.callback}/>
        <div style={{padding: '2%',}} className="pageContent">
            {this.props.children}
        </div>
      </div>
        

  }
}

export default Page

